export const useGetTeamKey = name => ['useGetTeamKey', name];
